export const InstantSmsTypes = {
	INSTANT_CLEAN_SMS_REDUCER: "INSTANT_CLEAN_SMS_REDUCER",
	INSTANT_SMS_INSERT_USER: "INSTANT_SMS_INSERT_USER",
	INSTANT_SMS_INSERT_SEND_FORM: "INSTANT_SMS_INSERT_SEND_FORM",
	INSTANT_SMS_INSERT_RECIPIENT: "INSTANT_SMS_INSERT_RECIPIENT",
	INSTANT_SMS_INSERT_BODY: "INSTANT_SMS_INSERT_BODY",
}
